import React from 'react';
import Routes from './routes';

import Global from './themes/global';

function App() {
  return (
    <>
      <Global />
      <Routes />
    </>
  );
}

export default App;
